import { type Options } from 'got'

export const parseInitHeaders = (headers: HeadersInit): Options['headers'] => {
  if (headers instanceof Headers) {
    return Object.fromEntries(headers.entries())
  }

  const headersObject = Array.isArray(headers) ? Object.fromEntries(headers) : headers
  return headersObject
}
